import { FlexBox } from '@airship-platform/jam-web/components';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export type DiscountsNameSortOrder = 'asc' | 'desc';

export type DiscountsQueryInputs = {
  searchTerm: string;
  nameSortOrder: DiscountsNameSortOrder;
};

export const DiscountsQuerySchema = z.object({
  searchTerm: z.string(),
  nameSortOrder: z.enum(['asc', 'desc']),
});

const DiscountsQueryForm: React.FC = () => {
  const { control } = useFormContext<DiscountsQueryInputs>();

  return (
    <FlexBox flexDirection={'column'} width={'100%'} gap={2}>
      <Controller
        name="searchTerm"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            placeholder={'Search by name or description'}
            type="search"
            fullWidth
            autoComplete="off"
          />
        )}
      />

      <Controller
        name="nameSortOrder"
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} row>
            <FormControlLabel
              value="asc"
              control={<Radio size="small" />}
              label={<Typography variant="caption">Name: A to Z</Typography>}
            />
            <FormControlLabel
              value="desc"
              control={<Radio size="small" />}
              label={<Typography variant="caption">Name: Z to A</Typography>}
            />
          </RadioGroup>
        )}
      />
    </FlexBox>
  );
};

export default DiscountsQueryForm;
